import classNames from "classnames";

import styles from "./UI.module.css";

const SIZE_CLASS = {
    18: styles.spinner18,
    32: styles.spinner32,
    60: styles.spinner60,
};

/**
 * Replaces MUI's <CircularProgress> with a CSS-animated ring.
 *
 * Defaults to `currentColor` so the spinner is legible wherever it is used — on
 * the red primary button that means white. Pass color="primary" for the standalone
 * spinners that sit on a card background.
 */
export function CircularProgress({
    className,
    color,
    hidden = false,
    size = 18,
}) {
    return (
        <span
            aria-hidden={hidden || undefined}
            className={classNames(
                styles.spinner,
                SIZE_CLASS[size] ?? styles.spinner18,
                color === "primary" && styles.spinnerPrimary,
                hidden && styles.spinnerHidden,
                className,
            )}
            role="progressbar"
        />
    );
}

/**
 * Replaces MUI's <Tooltip>. CSS-only via `content: attr(data-tooltip)`.
 *
 * Unlike MUI's, this works when the child is disabled — the wrapper receives the
 * hover, not the control — so the "Remember Me is only available with the Unixi
 * extension" hint still shows on the disabled checkbox.
 */
export function Tooltip({ children, className, title }) {
    return (
        <span
            className={classNames(styles.tooltip, className)}
            data-tooltip={title}
        >
            {children}
        </span>
    );
}
